export default "__VITE_ASSET__9178baad__"